/**
 * Canonical hospitality lists used across hotel-admin + master-admin editors.
 *
 * Room amenities (35) — features inside a single room.
 * Hotel facilities (40) — property-wide services & features.
 *
 * Treat these as the source of truth — backends accept arbitrary strings,
 * but UIs prefer these for consistent badges/filtering.
 */

export const ROOM_AMENITIES = [
  // Climate / comfort
  'Air Conditioning',
  'Heating',
  'Fan',
  // Bed & bath
  'King Bed',
  'Queen Bed',
  'Twin Beds',
  'Bunk Bed',
  'Extra Pillows',
  'Premium Bedding',
  'En-suite Bathroom',
  'Shower',
  'Bathtub',
  'Hair Dryer',
  'Bath Amenities',
  'Bathrobes & Slippers',
  // Connectivity
  'Free WiFi',
  'Cable / Satellite TV',
  'Smart TV',
  'Streaming Services',
  'Work Desk',
  'In-room Safe',
  // Food & beverage
  'Mini-bar',
  'Tea / Coffee Maker',
  'Kettle',
  'Mini-fridge',
  'Microwave',
  // Living comforts
  'Balcony',
  'Sea View',
  'Mountain View',
  'City View',
  'Garden View',
  'Soundproof',
  'Blackout Curtains',
  // Accessibility / family
  'Wheelchair Accessible',
  'Cot / Crib Available',
];

export const HOTEL_FACILITIES = [
  // Reception & services
  '24-hour Front Desk',
  'Concierge Service',
  'Multilingual Staff',
  'Express Check-in',
  'Luggage Storage',
  'Airport Shuttle',
  'Valet Parking',
  'Free Parking',
  'EV Charging Station',
  // Food & beverage
  'On-site Restaurant',
  'Room Service',
  'Breakfast Buffet',
  'Bar / Lounge',
  'Coffee Shop',
  'Pool-side Bar',
  // Wellness & leisure
  'Swimming Pool',
  'Heated Pool',
  'Kids Pool',
  'Spa',
  'Sauna',
  'Steam Room',
  'Fitness Center',
  'Yoga Studio',
  // Business & events
  'Business Centre',
  'Meeting Rooms',
  'Banquet Hall',
  'Wedding Venue',
  'Conference Facilities',
  // Family & accessibility
  'Family Rooms',
  'Kids Play Area',
  'Babysitting Service',
  'Wheelchair Accessible Lobby',
  'Pet-friendly',
  // Safety & policies
  'CCTV in Common Areas',
  'Smoke Detectors',
  'Fire Extinguishers',
  'First-aid Kit',
  '24-hour Security',
  // Add-ons
  'Free WiFi (lobby)',
  'Laundry Service',
];
